import { useQuery, QueryHookOptions } from '@apollo/client';

import { CHILDREN_BY_GROUP_SLUG } from './queries';
import { Child } from './types';

export const useChildrenByGroupSlug = (slug: string | undefined, options?: QueryHookOptions) =>
  useQuery<{ groupBySlug: { name: string; children: Child[] } }>(CHILDREN_BY_GROUP_SLUG, { ...options, skip: !slug, variables: { slug } });
